// CCP inherits table constants from default
import defaultFrontendRoutesConstants from './default';

export default defaultFrontendRoutesConstants;
